import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoAdvice extends Component {

    render() {
        const { advice } = this.props;
        const summary = getTitleSummary(advice)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Рекомендации'],
                    rows: summary
                }}
                expanded={(advice.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Описание',
                        'Примечание',
                        'Действия',
                        'Применяются',
                        'Нормативный документ'
                    ],
                    rows: advice.map(({
                        to_date = null,
                        description = '',
                        instruction = '',
                        action = '',
                        mark = '',
                        order, order_date, orders_info = null
                    }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        description,
                        instruction,
                        action,
                        mark === 0 ? 'нет' : 'да',
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoAdvice.js